module.exports = __webpack_public_path__ + "img/104.6.f8157ddf.png";